export const NEW_MESSAGE = 'message-service:newMessage'
export const NEW_CONVERSATION = 'message-service:newConversation'
export const CONVERSATION_DELETED = 'message-service:conversationDeleted'
export const SYSTEM_NOTIFICATION = 'message-service:systemNotification'
export const RE_AUTH = 'ccp-service:reAuth'
export const NEW_ALERT = 'message-service:newAlert'
export const UPGRADE_REDIRECT = 'message-service:upgradeRedirect'
export const ACCOUNT_UPGRADED = 'ccp-service:accountUpgraded'
export const TYPING = 'ccp-interface:typing'
export const RECURRING_UPDATED = 'ccp-service:recurringUpdated'

export const UT = {
  USER: 'user',
}

export const MODES = {
  WIDGET: 'widget',
  SIDEBAR: 'sidebar',
  VERTICAL: 'vertical',
  CHAT_LIST: 'chat-list',
}

export const OFFLINE = 'offline'
export const ONLINE = 'online'

export const LOCALSTORAGE_SESSION_KEY = 'chat-auth'

export const MESSAGE_TYPE_WARNING = 'warning'
export const MESSAGE_TYPE_UPGRADE = 'upgradeRequest'
export const MESSAGE_TYPE_SEXICONS_UPGRADE = 'upgradeSexiconsRequest'
export const MESSAGE_TYPE_IMAGE = 'image'
export const MESSAGE_TYPE_DEFAULT = 'message'
export const MESSAGE_TYPE_SEXICON = 'sexicon'
export const MESSAGE_TYPE_GIFT = 'gift'
export const MESSAGE_TYPE_GIFT_REVEAL = 'giftReveal'
export const MESSAGE_TYPE_SYSTEM  = 'systemNotification'
export const MESSAGE_TYPE_CONTACT_INFO  = 'contactInfoDetected'
export const MESSAGE_TYPE_FEATURED_AP_UNLOCK  = 'upgradeFeaturedAPUnlockRequest'
export const MESSAGE_TYPE_VOICE = 'voice'
export const DEFAULT_BLOCKED_MESSAGE = 'You must upgrade your account in order to continue chatting.'

export const UPGRADE_LINK_CLICK_SUCCESS = 'upgradeLinkClicked'
export const UPGRADE_LINK_CLICK_FAILED = 'failedUpgradeRedirect'

export const PENDING_MESSAGE_ID = 9999999999
export const MESSAGE_MAX_CHARS = 200
